import React, { useContext, useState, useEffect } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'
import { copyText, goToUrlTarget } from '../../lib/easybake'
import Refresh from '@react/react-spectrum/Icon/Refresh'
import Well from '@react/react-spectrum/Well'
import Button from '@react/react-spectrum/Button'
import Textfield from '@react/react-spectrum/Textfield'
import Heading from '@react/react-spectrum/Heading'
import Checkmark from '@react/react-spectrum/Icon/Checkmark'
import Copy from '@react/react-spectrum/Icon/Copy'
import Visibility from '@react/react-spectrum/Icon/Visibility'
import VisibilityOff from '@react/react-spectrum/Icon/VisibilityOff'
import {
    getQuota
} from '../../lib/consoleApi'
import {
    STATUS_CODE_SUCCESS_OK
} from '../../lib/constants'

import Ps from '../../asset/img/ps.svg'

export default function WizardProjectInfo () {
    const { ut, page, cred } = useContext(EasybakeContext)
    const [copyStateApiKey, setCopyStateApiKey] = useState(false)
    const [copyStateClientSecret, setCopyStateClientSecret] = useState(false)
    const [quota, setQuota] = useState(false)
    const [clientSecret, setClientSecret] = useState(false)
    const [clientSecretTextFieldType, setClientSecretTextFieldType] = useState(true)

    useEffect(() => {
        getQuotaApi()
    }, [])

    function getPlanType(planCode) {
        switch (planCode) {
            case 'PS_FREE_TRIAL':
                return 'Free Trial'
            case 'PS_PAYG_PLAN':
                return 'AWS Marketplace'
            default:
                return 'Enterprise'
        }
    }

    function copyActionApiKey(e, target) {
        analytics.sendEventName('click', `${page}:copyapikey`)
        copyText(target, page)
        setCopyStateApiKey(true)
        setTimeout(() => setCopyStateApiKey(false), 600);
    }

    function copyActionClientSecret(e, target) {
        analytics.sendEventName('click', `${page}:copyclientsecret`)
        copyText(target, page)
        setCopyStateClientSecret(true)
        setTimeout(() => setCopyStateClientSecret(false), 600);
    }

    async function getQuotaApi() {
        const res = await getQuota(ut, cred.orgId, cred.intId)
        if (res) {
            setQuota(res)
        }
    }

    return (
        <div className="adobe-easybake-main-wizard">
            <div className="adobe-easybake-flex-row">
                <div><Heading variant="subtitle1">{`${cred && cred.project && cred.project.name || cred && cred.projectName}`}</Heading></div>
                <div className="adobe-easybake-credinfo-logo"><img src={Ps} alt="" className="sub-nav-icon-small" /></div>
                <div>{__('console_credinfo_ps_api_service')}</div>
            </div>
            {/* <div className="adobe-easybake-flex-row"><Heading variant="subtitle1">{__('console_credinfo_cc_title')}</Heading></div> */}
            <div className="adobe-easybake-flex-row"><Heading variant="subtitle2">{__('console_credinfo_apikey_title')}</Heading></div>
            <div className="adobe-easybake-flex-row">
                <div className='adobe-easybake-credinfo'>{`${cred && cred.apiKey}`}</div>
                <div className="adobe-easybake-credinfo-button">
                    { copyStateApiKey ? <Button
                        style={{
                        alignItems: 'center',
                        backgroundColor: '#12805C',
                        padding: '0px 36px'
                        }}
                        icon={<Checkmark style={{color: '#ffffff'}} />}
                        variant="action"
                    /> : <Button variant="action"
                        icon={<Copy />}
                        onClick={ e => copyActionApiKey(e, cred && cred.apiKey) }>{__('console_credinfo_btn_copy')}
                    </Button>}
                </div>
            </div>
            <div className="adobe-easybake-flex-row"><Heading variant="subtitle2">{__('console_credinfo_client_secret_title')}</Heading></div>
            { cred.clientSecret && <div className="adobe-easybake-flex-row">
                <Textfield
                    readOnly
                    id="tf-cs"
                    className="adobe-easybake-input-like-div"
                    defaultValue={cred.clientSecret.client_secret}
                    type={clientSecretTextFieldType ? 'password' : ''}/>
                <Button variant="action"
                    style={{
                    alignItems: 'center',
                    paddingRight: '1px'
                    }}
                    icon={clientSecretTextFieldType ? <Visibility /> : <VisibilityOff />}
                    onClick={ e => setClientSecretTextFieldType(!clientSecretTextFieldType) }> </Button>
                <div className="adobe-easybake-credinfo-button">
                    { copyStateClientSecret ? <Button
                        style={{
                        alignItems: 'center',
                        backgroundColor: '#12805C',
                        padding: '0px 36px'
                        }}
                        icon={<Checkmark style={{color: '#ffffff'}} />}
                        variant="action"
                    /> : <Button variant="action"
                        icon={<Copy />}
                        onClick={ e => copyActionClientSecret(e, cred && cred.clientSecret && cred.clientSecret.client_secret) }>{__('console_credinfo_btn_copy')}
                    </Button>}
                </div>
            </div>
            }
            {quota && quota.data && quota.status === STATUS_CODE_SUCCESS_OK && quota.data.planCode === 'PS_FREE_TRIAL' && <div>
                <div className="adobe-easybake-flex-row">
                    <Heading variant="subtitle2">{__("signup_wizard_your_plan_title")}</Heading>
                </div>
                <div className="adobe-easybake-flex-row">
                    <div className='adobe-easybake-credinfo'>{getPlanType(quota.data.planCode)}</div>
                    {quota.data.planCode === 'PS_FREE_TRIAL' && <div className="adobe-easybake-credinfo-button">
                        <Button variant="action" onClick={ e => goToUrlTarget(`${process.env.REACT_APP_CONFIG_APP_DEV_SITE}/photoshop/api/pricing`, '_blank') }>{__("signup_wizard_btn_upgrade")}</Button>
                    </div>}
                </div>
            </div>}
        </div>
    )
}
